module.exports = __webpack_public_path__ + "img/roteSpitze.4eb22ac1.jpg";